import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappconsolidatedreportbody} from './bodyappconsolidatedreportbody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './withRouter'
class Bodyappconsolidtaedreport extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappconsolidatedreportbody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappconsolidtaedreport);